'use client';

import { useEffect, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DebouncedFunctionType = (...args: any[]) => void;

export function useDebounce<CallbackType extends DebouncedFunctionType>(
    callback: CallbackType,
    delay: number,
) {
    const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

    useEffect(
        () => () => {
            if (!timer.current) return;
            clearTimeout(timer.current);
        },
        [],
    );

    return ((...args) => {
        const newTimer = setTimeout(() => {
            callback(...args);
        }, delay);
        clearTimeout(timer.current);
        timer.current = newTimer;
    }) as CallbackType;
}
